export default {
  buttons: {
    save: 'Save',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  confirmation: {
    title: 'Are you sure you want to sync to external services?',
  },
};
